export function formatDistance(meters) {
  if (meters == null) return '—';
  if (meters < 1000) return `${Math.round(meters)} m`;
  return `${(meters / 1000).toFixed(1)} km`;
}

export function formatDuration(seconds) {
  if (seconds == null) return '—';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m} min`;
  return `< 1 min`;
}

export function formatCoords(lat, lng) {
  const latDir = lat >= 0 ? 'N' : 'S';
  const lngDir = lng >= 0 ? 'E' : 'W';
  return `${Math.abs(lat).toFixed(4)}° ${latDir}, ${Math.abs(lng).toFixed(4)}° ${lngDir}`;
}

export function waypointLabel(index, total) {
  if (total === 1) return 'A';
  if (index === 0) return 'A';
  if (index === total - 1) return String.fromCharCode(65 + Math.min(index, 25));
  return String.fromCharCode(65 + Math.min(index, 25));
}

export function waypointRole(index, total) {
  if (total <= 1) return 'start';
  if (index === 0) return 'start';
  if (index === total - 1) return 'end';
  return 'mid';
}

export function formatDate(isoString) {
  const d = new Date(isoString);
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

// Firebase Auth only sets displayName for providers that supply a profile
// (Google, etc.) — email-link and plain email/password sign-in leave it null,
// which used to fall back to the literal string "Anonymous" everywhere a name
// was recorded (registrations, published routes, reviews...). Derive something
// friendlier from the email's local part instead: "dana.smith92@..." → "Dana".
export function bestDisplayName(user) {
  if (user?.displayName) return user.displayName;
  const local = (user?.email || '').split('@')[0];
  if (!local) return 'Rider';
  const first = local.split(/[._+\-0-9]+/).filter(Boolean)[0];
  const base = (first && first.length >= 2) ? first : local;
  return base.charAt(0).toUpperCase() + base.slice(1).toLowerCase();
}
